module.exports = __webpack_public_path__ + "assets/img/gouwuche.8cb656e2.png";